// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-banner {
  position: fixed;
  right: 0;
  bottom: 250px;
  background-color: #009DD9;
  color: #FFF;
  box-shadow: 0px 0px 12px 0px #777;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
}
.feedback-banner__icon {
  display: inline-block;
  padding: 10px;
  font-size: 18px;
  vertical-align: middle;
}
.feedback-banner__text {
  display: inline-block;
  visibility: hidden;
  width: 0;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 14px;
  height: 28px;
  transition: width 0.5s;
}
.feedback-banner:hover .feedback-banner__text {
  visibility: visible;
  width: 120px;
  transition: width 0.5s;
}
.feedback-banner.pulsing {
  animation: pulse 1s infinite;
}

.feedback-form {
  position: fixed;
  bottom: 100px;
  width: 400px;
  right: 10px;
  background-color: #FFF;
  border-radius: 6px;
  border: 1px solid #888;
  box-shadow: 0px 0px 12px 0 #777;
  padding: 25px;
}
.feedback-form .remove-button {
  font-size: 24px;
  float: right;
  cursor: pointer;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
